export default __webpack_public_path__ + "static/media/sidebar-1.44779c5f.jpg";